(() => {
  const desktop = window.matchMedia('(min-width: 990px)');
  const timers = new WeakMap();
  const cancel = el => { clearTimeout(timers.get(el)); timers.delete(el); };
  const close = el => {
    cancel(el);
    el.open = false;
    el.querySelectorAll('details[open]').forEach(child => { cancel(child); child.open = false; });
  };
  const keyboardWithin = el => el.contains(document.activeElement) && document.activeElement?.matches(':focus-visible');
  function init() {
    document.querySelectorAll('[data-shopde-shop], [data-shopde-shop-world]').forEach(el => {
      if (el.dataset.shopInitialized) return;
      el.dataset.shopInitialized = 'true';
      const summary = el.querySelector(':scope > summary');
      summary.setAttribute('aria-expanded', String(el.open));
      el.addEventListener('toggle', () => {
        summary.setAttribute('aria-expanded', String(el.open));
        if (el.open && el.matches('[data-shopde-shop-world]')) {
          el.parentElement.querySelectorAll(':scope > details[open]').forEach(other => { if (other !== el) close(other); });
        }
      });
      el.addEventListener('pointerenter', event => {
        if (desktop.matches && event.pointerType === 'mouse') { cancel(el); el.open = true; }
      });
      el.addEventListener('pointerleave', event => {
        if (event.pointerType === 'mouse' && !keyboardWithin(el)) timers.set(el, setTimeout(() => close(el), 200));
      });
      el.addEventListener('focusout', event => { if (!el.contains(event.relatedTarget)) close(el); });
      el.addEventListener('keydown', event => {
        if (event.key === 'Escape' && el.open) { event.preventDefault(); event.stopPropagation(); close(el); summary.focus(); }
      });
    });
  }
  document.addEventListener('pointerdown', event => document.querySelectorAll('[data-shopde-shop][open]').forEach(el => { if (!el.contains(event.target)) close(el); }));
  desktop.addEventListener('change', () => { if (!desktop.matches) document.querySelectorAll('[data-shopde-shop][open]').forEach(close); });
  document.addEventListener('shopify:section:load', init);
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init, { once: true });
  else init();
})();
